import { render } from "./setup-password.vue?vue&type=template&id=ee49ee16&scoped=true&ts=true"
import script from "./setup-password.vue?vue&type=script&lang=ts"
export * from "./setup-password.vue?vue&type=script&lang=ts"

import "./setup-password.vue?vue&type=style&index=0&id=ee49ee16&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee49ee16"]])

export default __exports__